import { createSelector } from '@app/utils/createSelector'

import { createReduxSlice } from '@app/store/redux_slice'

import { activeCoursesSelector } from './lessons'

export type AcademyFilter = {
  age?: number
  /** list of course ids */
  courses: string[]
  start?: number
  end?: number
}

const academyFilterSlice = createReduxSlice<AcademyFilter>('academy_filter')

export const setAcademyFilter = (filter: AcademyFilter) => academyFilterSlice.set(filter)

export const filterSelector = createSelector([academyFilterSlice.selector, activeCoursesSelector], (filter, courses) => {
  const value = filter ?? DEFAULT_FILTER
  return {
    ...value,
    courses: courses.filter(c => value.courses.indexOf(c.course.id) !== -1).map(c => c.course.id),
  }
})

const DEFAULT_FILTER: AcademyFilter = { age: 0, courses: [] }
